<template>
    <div>
        <div class="comment_btn__wrapper audio" @click="startRecordAction" v-if="!settings.recordInProgressBool">
            <inline-svg :src="require('@/assets/icons/microphone_record.svg')"
                        :fill="settings.primaryColor"/>
        </div>
        <div class="spin circle" @click='stopRecordAction' :class="{active: settings.recordInProgressBool}">
            <inline-svg :src="require('@/assets/icons/stop_record_icon.svg')"/>
            <div id="container">
                <div id="halfclip">
                    <div class="halfcircle" id="clipped">
                    </div>
                </div>
                <div class="halfcircle" id="fixed">
            </div>
        </div>
</div>
    </div>
</template>

<script>
import errorMixin from '@/mixins/errorMixin';
import logAnalyticsEvent from '@/helpers/analytics'
import InlineSvg from 'vue-inline-svg';
export default {
    components: {
        InlineSvg,
    },
    mixins: [mixin, errorMixin],
    data() {
        return {
            
        }
    },
    props: {
        settings: {
                type: [Object, null],
                default: () => {
                    return {}
                    }
                },
        },
    methods: {
        async startRecordAction() {
            if(this.settings.startRecord) {
                try {
                    await this.settings.startRecord(this.settings)
                } catch (error) {
                    this.showErrorModal(error.massage)
                }
            }
        },
        async stopRecordAction() {
            if(this.settings.stopRecord) {
                try {
                    await this.settings.stopRecord(this.settings)
                } catch (error) {
                    this.showErrorModal(error.massage)
                }
            }
        }
    }
}
</script>

<style>
    button::before,
    button::after {
        box-sizing: inherit;
        content: '';
        position: absolute;
        width: 35px;
        height: 35px;
        transition: none;
    }
    .spin {
        display: none;
        position: absolute;
        right: 95px;
        bottom: 2px;
        cursor: pointer;
        height: auto;
        width: 30px;
        transition: none;
    }
    .spin img {
        color: red;
    }
    .spin::before,
    .spin::after {
        top: 0;
        left: -3px;
        transition: none;
    }
    .spin::before {
        border: 2px solid transparent;
    }
    .spin::after {
        border: 0 solid transparent;
    }
    .circle {
        border-radius: 100%;
        box-shadow: none;
        border: none;
        background-color: transparent;
    }

    .circle::before,
    .circle::after {
        border-radius: 100%;
    }
    .spin.circle.active {
        display: block;
    }
    .spin:hover::before {
        border-top-color: red;
        border-right-color: red;
        border-bottom-color: red;
        transition: border-top-color 0.15s ease-out, border-right-color 0.15s ease-out 0.10s, border-bottom-color 0.15s ease-out 0.20s;
    }
    .spin:hover:after {
        border-top: 2px solid red;
        border-left-width: 2px;
        border-right-width: 2px;
        transform: rotate(270deg);
        transition: transform 0.4s ease-out 0s, border-left-width 0s ease-out 0.35s, -webkit-transform 0.4s ease-out 0s;
    }
    .comment_btn__wrapper.audio {
        position: absolute;
        right: 95px;
        bottom: 6px;
        cursor: pointer;
    }
    .comment_btn__wrapper.audio svg {
        width: 21px;
        height: 21px;
    }
     .comment_btn__wrapper.audio-stop {
        width: 20px;
        height: 20px;
        font-size: 0;
        background-color: red;
        border: 0;
        border-radius: 35px;
        outline: none;
        position: absolute;
        right: 98px;
        bottom: 12px;
        cursor: pointer;
        display: none;
    }
    .comment_btn__wrapper.audio-stop::after,.comment_btn__wrapper.audio-stop::before {
        box-sizing: inherit;
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
    }
    .comment_btn__wrapper.audio-stop.active {
        display: block;
        animation-name: pulse;
        animation-duration: 1.5s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }

    @keyframes circle{
        0%{
            box-shadow: 0px 0px 5px 0px rgba(173,0,0,.3);
            
        }
        65%{
            box-shadow: 0px 0px 5px 10px rgba(173,0,0,.3);
           
        }
        90%{
            box-shadow: 0px 0px 5px 10px rgba(173,0,0,0);
            
        }
    }
#container {
    position: absolute;
    width: 35px;
    height: 35px;
    animation: colors 4s infinite;
    right: -3px;
    bottom: 4px;
}

#halfclip {
  width: 50%;
  height: 100%;
  right: 0px;
  position: absolute;
   overflow: hidden;
   transform-origin: left center;
   animation: cliprotate 60s steps(2) infinite;
   -webkit-animation: cliprotate 60s steps(2) infinite;
}

.halfcircle {
  box-sizing: border-box;
  height: 100%;
  right: 0px;
  position: absolute;
  border: solid 4px transparent;
   border-top-color: red;
   border-left-color: red;
   border-radius: 50%;
}
#clipped {
  width: 200%;
   animation: rotate 30s linear infinite;
   -webkit-animation: rotate 30s linear infinite;
}
#fixed {
  width: 100%;
    transform: rotate(137deg);  
   animation: showfixed 60s steps(2) infinite;
   -webkit-animation: showfixed 60s linear infinite;
}

@-webkit-keyframes cliprotate {
  0% {transform: rotate(0deg);}
  100% {transform: rotate(360deg);}
}

@keyframes cliprotate {
  0% {transform: rotate(0deg);}
  100% {transform: rotate(360deg);}
}


@-webkit-keyframes rotate {
  0% {transform: rotate(-45deg);}
  100% {transform: rotate(135deg);}
}

@keyframes rotate {
  0% {transform: rotate(-45deg);}
  100% {transform: rotate(135deg);}
}

@-webkit-keyframes showfixed {
  0% {opacity: 0;}
  49.9% {opacity: 0;}
  50% {opacity: 1;}
 100% {opacity: 1;}
}
</style>